import React from "react"
import checkIfUserCanApplyLoan from "../../../Utils/customHooks/useCheckIfUserCanApply"
const TextImageSection = (props) => {
 
  const applyNow = checkIfUserCanApplyLoan();
  return (
    <div className={`${props?.view} ${props?.custumeClass} ${props?.loader ? 'loader-on-section':''}`}>
      {props?.heading ? (
        <div className="image-overlaping-text">
          <h1 className="first-line-heading">{props?.heading}</h1>
          {props?.headingSecond ? (
            <h1 className="second-line-heading">{props?.headingSecond}</h1>
          ) : null}
          {props?.button ? (
            <button className="apply-button" onClick={()=>applyNow()}>
              <span className="button-text">Apply Now</span>
            </button>
          ) : null}
        </div>
      ) : null}
      {props?.image && !props?.loader ? (
        <img className="image-section-image" src={props?.image} alt="Example" />
      ) : <div class="loader"></div>}
      
    </div>
  )
}

export default TextImageSection
